import Cookies from "js-cookie";
import { isEmpty } from "@/utils/validation";
const uuidv4 = require("uuid/v4");

const basket_name = "u_basket"; //购物车id
const guest_name = "u_guest"; //游客id
const device_name = "u_device"; //设备id
const token_name = "u_token"; //用户token
const browser_name = "u_browser"; //浏览器
const uid_name = "u_id"; //用户id
const u_number = "u_number"; //用户number
const expires_day = 1;

/**
 *  @description 创建根据cookie名的 uuid 保存到cookie
 */
let createUuid = (cookieName) => {
    if (!cookieName) return;
    return () => {
        Cookies.set(cookieName, `${uuidv4()}`, {
            expires: Number.Infinity,
        });
    };
};

/**
 * @description 根据cookie名 删除 cookie
 */
let removeCookies = (cookieName) => {
    if (!cookieName) return;
    return () => {
        Cookies.remove(cookieName);
    };
};

/**
 * @description 根据cookie名获取cookie
 */
let getCookies = (cookieName) => {
    if (!cookieName);
    return () => {
        return Cookies.get(cookieName) || "";
    };
};

/**
 * @description 设置用户token
 */
let setUserToken = (token) => {
    if (!token) return;
    Cookies.set(token_name, token, {
        expires: expires_day,
    });
};

/**
 * @description 设置用户number
 */
let setUserNumber = (number) => {
    if (!number) return;
    Cookies.set(u_number, number, {
        expires: expires_day,
    });
};

let getUserNumber = getCookies(u_number);

/**
 * @description 获取用户token
 */
let getUserToken = getCookies(token_name);

/**
 * @description 删除用户token
 */
let removeUserToken = removeCookies(token_name);

/**
 * @description 创建游客uuid
 */
let createGuest = createUuid(guest_name);

/**
 * @description 获取游客uuid
 */
let getGuest = getCookies(guest_name);

/**
 * @description 删除游客
 */
let removeGuest = removeCookies(guest_name);

/**
 * @description 创建设备uuid
 */
let createDevice = createUuid(device_name);

/**
 * @description 获取设备uuid
 * 
 */
let getDevice = getCookies(device_name);

/**
 * @description 删除设备
 */
let removeDevice = removeCookies(device_name);

/**
 * @description 创建购物车uuid
 */
let createBasket = createUuid(basket_name);

/**
 * @description 获取购物车id
 */
let getBasket = getCookies(basket_name);

/**
 * @description 删除购物车
 */
let removeBasket = removeCookies(basket_name);

/**
 * @description 创建浏览器
 */
let createBrowser = () => {
    Cookies.set(cookieName, `${uuidv4()}`, {
        expires: Number.Infinity,
    });
};

/**
 * @description 检测用户是否登录
 */
let isLogin = () => {
    let token = getUserToken();
    return !isEmpty(token);
};

/**
 * @description 设置用户id
 */
let setUserId = (uid) => {
    if (!uid) return;
    Cookies.set(uid_name, uid, {
        expires: expires_day,
    });
};

/**
 * @description 获取用户id
 */
let getUserId = getCookies(uid_name);

/**
 * @description 删除用户id
 */
let removeUserId = removeCookies(uid_name);

/**
 * @description 初始化顾客信息
 */
let initGustInfo = () => {
    let guestId = getGuest();
    let basketId = getBasket();
    let deviceId = getDevice();
    if (!isLogin()) {
        if (!guestId) {
            createGuest();
        }
        if (!basketId) {
            createBasket();
        }
        if (!deviceId) {
            createDevice();
        }
    }
};

export {
    setUserToken,
    getUserToken,
    removeUserToken,
    createGuest,
    getGuest,
    removeGuest,
    createDevice,
    getDevice,
    removeDevice,
    createBasket,
    getBasket,
    removeBasket,
    isLogin,
    getUserId,
    setUserId,
    removeUserId,
    initGustInfo,
    setUserNumber,
    getUserNumber,
};
